import React, { Component } from "react";
import { withRouter } from "react-router-dom";

var configs = require("../../../../public/config.json");

import CommonHeader from "../../../components/Common/Header";
import Api from "../../../lib/componentApi";
import getComponentData from "../../../lib/getComponentData";
import mixpanel from "../../../lib/mixPanel";
import getLocalData from "../../../lib/getLocalData";

import List from "../../../components/Restaurants/List";
import RestaurantsLoading from "../../../components/Loadings/Restaurants";
import Basket from "../../../components/Common/Basket";
import SearchDesktop from "../../../components/Restaurants/Search/Desktop";
import getInAppConfigs from "../../../lib/inAppConfigs";
import capitalizeFirstLetter from "../../../lib/capitalizeFirstLetter";

//Components
import MobileFilterSection from "./components/List/MobileFilterSection";
import DesktopSearchBar from "./components/List/DesktopSearchBarSection";
import Breadcrumbs from "./components/List/Breadcrumbs";
import LoadMore from "./components/List/LoadMoreButton";
import setLocalDeliveryData from "../../../lib/setLocalDeliveryData";
import customUrlSearchParams from "../../../lib/customUrlSearchParams";
import Announcements from "../../../components/Restaurants/Announcements";

class Restaurants extends Component {
  constructor(props, context) {
    super(props, context);
    const staticContext = props.staticContext;
    const { initialData, mobile, serverData, otherData } = getComponentData(
      staticContext,
      "restaurants",
      "customRestaurantLists"
    );

    const searchParams = new customUrlSearchParams(props.location.search);
    let restaurants = [];
    let customList = null;
    if (initialData && initialData.length) {
      restaurants = initialData;
    }

    if (otherData && otherData.length) {
      customList = otherData;
    }
    let addressData;

    // eslint-disable-next-line
    if (__isBrowser__) {
      addressData = getLocalData("deliveryDetails");
    } else {
      addressData = serverData;
    }
    const matchParams = props.match.params;
    let delivery = true;
    if (addressData && typeof addressData.delivery === "boolean") {
      delivery = addressData.delivery;
    }

    const preOrder = searchParams.get("time")
      ? searchParams.get("time") === "now"
        ? ""
        : searchParams.get("time")
      : "";

    const limit = getInAppConfigs("restaurantsListLimit");
    this.state = {
      lat: (addressData && addressData.lat) || null,
      lon: (addressData && addressData.lon) || null,
      routeName: (addressData && addressData.routeName) || "",
      postalCode: searchParams.get("postcode"),
      adminWard:
        (addressData && addressData.adminWard) || matchParams.adminWard,
      adminWardName: (addressData && addressData.adminWardName) || "",
      city: (addressData && addressData.city) || matchParams.city,
      flatNumber: (addressData && addressData.flatNumber) || "",
      userAddressId: (addressData && addressData.userAddressId) || null,
      limit,
      isPostalCode: addressData ? addressData.isPostalCode : false,
      showOffline: true,
      delivery: delivery,
      index: 0,
      preOrder: (addressData && addressData.preOrder) || preOrder,
      restaurants,
      distance: (addressData && addressData.distance) || 0,
      changeDelivery: false,
      query: props.query || searchParams.get("query"),
      filterSection: false,
      orderBy: "DISTANCE",
      hasMore: !(restaurants.length < limit),
      search: false,
      maxDistance: configs.maxSearchDistanceValue || 2,
      defaultDistance: configs.defaultSearchDistanceValue || 1,
      preOrderStart: configs.preOrderStartDelay || 0,
      preOrderEnd: configs.preOrderEndInterval || 0,
      regexCategories: [],
      loading: !!props.search,
      visibleLoadMore: true,
      scrolled: false,
      isMobile: mobile,
      customList
    };
    // eslint-disable-next-line
    if (__isBrowser__ && window) {
      window.onscroll = () => {
        const {
          getRestaurants,
          state: { loading, hasMore, index, visibleLoadMore }
        } = this;
        let footerHeight = 50;
        if (window.innerWidth > 768) {
          footerHeight = 410;
        }
        if (window.scrollY > 530) {
          this.setState({
            scrolled: true
          });
        } else {
          this.setState({ scrolled: false });
        }
        if (loading || !hasMore || !restaurants.length || visibleLoadMore)
          return;
        if (
          window.innerHeight + document.documentElement.scrollTop >=
          document.documentElement.offsetHeight - footerHeight
        ) {
          this.setState({ index: index + limit }, () => {
            const { index } = this.state;
            mixpanel.track("Scroll Restaurant List", {
              _pageNumber: index / limit
            });
            getRestaurants();
          });
        }
      };
      //url'den gelmiş, önce lat lon al
      const { postalCode, city, preOrder } = this.state;
      if (!addressData && postalCode && city) {
        const apiPostalCode = postalCode || "00000";
        Api.post(
          "/api/route/data",
          { postalCode: apiPostalCode },
          (postalResponse, postalErros) => {
            if (postalErros) {
              if (postalErros === 503) {
                this.setState(() => {
                  throw postalErros;
                });
              } else {
                console.log(postalErros, "postal code query error");
              }
            } else if (postalResponse.code) {
              console.log(postalCode.response);
            } else {
              const { adminWard, city, lat, lon } = postalResponse;
              const addressData = {
                preOrder,
                postalCode,
                delivery: true,
                adminWard: adminWard.slugAdminWard,
                city: city.slugName,
                lat,
                lon,
                isPostalCode: true
              };
              const jsonData = JSON.stringify(addressData);
              setLocalDeliveryData(jsonData, () => {});
            }
          }
        );
      }
    }
  }
  updateDimensions() {
    const rightDiv = document.getElementById("right");

    if (rightDiv) {
      const rightDivWidth = rightDiv.getBoundingClientRect().x;
      const grayDiv = document.getElementById("left-gray");

      if (grayDiv && rightDivWidth) {
        grayDiv.style.width = rightDivWidth + 10 + "px";
      }
    }

    if (window.innerWidth >= 768) {
      const slider = document.querySelector(".alice-carousel__wrapper");
      if (slider) {
        document.querySelector(".alice-carousel").classList.add("classes");

        slider.style.paddingLeft = "11px";
        slider.style.marginLeft = "-12px";
        const carousel = document.querySelector(".alice-carousel");

        if (
          document.querySelector(".item-1") ||
          document.querySelector(".item-2") ||
          document.querySelector(".item-3")
        ) {
          carousel.style.width = carousel.offsetWidth + 5 + "px";
        }
      }
      if (document.querySelector(".custom-extra")) {
        const carousel2 = document.querySelector(
          ".custom-extra .alice-carousel"
        );
        const slider2 = document.querySelector(
          ".custom-extra .alice-carousel__wrapper"
        );
        carousel2.classList.add("classes");

        slider2.style.paddingLeft = "11px";
        slider2.style.marginLeft = "-12px";
        carousel2.style.width = carousel2.offsetWidth + 4.5 + "px";
      }
    }
  }

  componentDidMount() {
    const { search } = this.props;
    const { customList } = this.state;

    if (!customList) {
      this.getCustomList();
    }
    this.interval = null;
    if (search) {
      this.getRestaurants();
    }

    this.updateDimensions();

    window.addEventListener("resize", this.updateDimensions);
  }
  getCustomList = () => {
    const {
      delivery,
      showOffline,
      lat,
      lon,
      userAddressId,
      preOrder,
      distance
    } = this.state;

    const variables = {
      limit: 20,
      index: 0,
      showOffline,
      lat,
      lon,
      userAddressId,
      delivery,
      preOrder,
      collectionDistance: distance
    };
    Api.post("/api/restaurants/custom", variables, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw response;
          });
        } else {
          console.log(response, "custom list query error");
        }
      } else if (response.code) {
        console.log(response, "code-custom-query");
      } else {
        const customList = response || [];
        this.setState({ customList });
      }
    });
  };
  getCompleteData = () => {
    clearTimeout(this.interval);
    const {
      lat,
      lon,
      delivery,
      limit,
      showOffline,
      userAddressId,
      query,
      preOrder,
      distance,
      orderBy,
      index
    } = this.state;
    let completeData = {
      lat,
      lon,
      delivery,
      limit,
      showOffline,
      userAddressId,
      query,
      preOrder,
      distance,
      orderBy,
      index
    };
    Api.post("/api/complete", completeData, (response, errors) => {
      if (errors) {
        if (errors === 503) {
          this.setState(() => {
            throw errors;
          });
        } else {
          console.log(errors);
        }
      } else if (response.code) {
        console.log(response, "code");
      } else {
        this.setState({ regexCategories: response });
      }
    });
  };
  getRestaurants = async () => {
    let {
      lat,
      lon,
      delivery,
      limit,
      showOffline,
      userAddressId,
      query,
      preOrder,
      distance,
      orderBy,
      index
    } = this.state;
    if (typeof userAddressId !== "number") {
      userAddressId = null;
    }
    this.setState({ loading: true });
    await Api.get(
      "/api/restaurants",
      {
        lat,
        lon,
        delivery,
        index,
        limit,
        showOffline,
        userAddressId,
        query,
        preOrder,
        distance,
        orderBy
      },
      (response, errors) => {
        if (errors) {
          if (errors === 503) {
            this.setState(() => {
              throw errors;
            });
          } else {
            console.log(errors);
          }
        } else if (response.code) {
          console.log(response, "restaurants-code");
        } else {
          const { restaurants, limit } = this.state;
          if (query) {
            this.setState({
              hasMore: false,
              restaurants: response
            });
          } else {
            if (response.length) {
              if (limit <= response.length) {
                if (index === 0) {
                  this.setState({
                    hasMore: true,
                    restaurants: response
                  });
                } else {
                  this.setState({
                    hasMore: true,
                    restaurants: [...restaurants, ...response]
                  });
                }
              } else {
                this.setState({
                  hasMore: false,
                  restaurants: [...restaurants, ...response]
                });
              }
            } else {
              if (index === 0) {
                this.setState({
                  hasMore: false,
                  restaurants: response
                });
              } else {
                this.setState({
                  hasMore: false,
                  restaurants: [...restaurants, ...response]
                });
              }
            }
          }
        }
        this.setState({ loading: false });
      }
    );
  };
  getFilter = status => {
    const {
      delivery,
      routeName,
      preOrder,
      postalCode,
      flatNumber
    } = this.state;
    let deliveryText, timeText;
    if (!status) {
      if (delivery) {
        deliveryText =
          (routeName && `${flatNumber || ""} ${routeName}`) || postalCode;
      } else {
        deliveryText = "Collection";
      }
      timeText = preOrder || "ASAP";
      return `${timeText} > ${deliveryText || ""}`;
    } else {
      if (status === "address") {
        if (delivery) {
          deliveryText =
            (routeName && `${flatNumber || ""} ${routeName}`) || postalCode;
        } else {
          deliveryText = "Collection";
        }
        return deliveryText;
      } else {
        timeText = preOrder || "ASAP";
        return timeText;
      }
    }
  };
  changeDeliveryDetails = event => {
    event.preventDefault();
    var body = document.body;
    body.classList.add("body-overflow");
    this.setState({ changeDelivery: true });
  };

  handleFilterSection = () => {
    const { filterSection } = this.state;
    var body = document.body;
    if (!filterSection) {
      mixpanel.track("Sort Click");
      body.classList.add("body-overflow");
    } else {
      body.classList.remove("body-overflow");
    }
    this.setState({ filterSection: !filterSection });
  };
  submitFilter = filter => {
    var body = document.body;
    body.classList.remove("body-overflow");

    mixpanel.track("Change Sort", {
      "Sort By": filter
    });

    this.setState(
      {
        filterSection: false,
        orderBy: filter,
        index: 0
      },
      () => {
        this.getRestaurants();
      }
    );
  };
  onCloseSection = section => {
    var body = document.body;
    body.classList.remove("body-overflow");
    this.setState({
      [section]: false
    });
  };
  onSubmitCategory = (
    categoryName,
    type,
    uid,
    restaurantPostCode,
    restaurantAdminWard,
    restaurantCity,
    slugName
  ) => {
    var element = document.getElementById("search-div");
    element.classList.remove("open-search");
    if (type === 1) {
      const { postalCode, preOrder } = this.state;
      const href = `/restaurant/${restaurantCity}/${restaurantAdminWard}/${slugName}/?postcode=${postalCode ||
        restaurantPostCode}&time=${preOrder || "now"}`;
      if (href) {
        location.href = href;
      }
    } else {
      const url = new URL(location.href);
      const queryString = url.search;
      const searchParams = new customUrlSearchParams(queryString);
      const newUrl = searchParams.setUrl("query", categoryName);
      url.search = newUrl.toString();
      const href = url.toString() || "";
      if (href && href.includes(categoryName)) {
        location.replace(href);
      }
    }
  };
  handleKeyUp = event => {
    event.preventDefault();
    const { query } = this.state;
    const self = this;
    if (query) {
      this.interval = setTimeout(self.getCompleteData.bind(self), 1000);
    }
  };
  onRemoveQuery = () => {
    this.setState({
      query: ""
    });
  };
  handleSearchBar = () => {
    var element = document.getElementById("search-div");
    element.classList.add("open-search");
    this.setState({
      searchBar: true
    });
  };
  handleCloseSearchBar = () => {
    setTimeout(
      function() {
        var element = document.getElementById("search-div");
        element.classList.remove("open-search");
        this.setState({
          searchBar: false
        });
      }.bind(this),
      300
    );
  };
  handleChangeQuery = event => {
    this.setState(
      {
        query: event.target.value
      },
      () => {
        if (this.state.query && !this.state.searchBar) {
          this.setState({
            searchBar: true
          });
        } else {
          if (!this.state.query) {
            this.setState({
              regexCategories: []
            });
          }
        }
      }
    );
  };
  getMoreRestaurants = () => {
    const { limit, index } = this.state;
    this.setState({ index: index + limit, visibleLoadMore: false }, () => {
      mixpanel.track("Scroll Restaurant List", {
        _pageNumber: this.state.index / this.state.limit
      });
      this.getRestaurants();
    });
  };
  render() {
    const { search } = this.props;
    const {
      restaurants,
      loading,
      lat,
      lon,
      userAddressId,
      changeDelivery,
      query,
      searchBar,
      regexCategories,
      filterSection,
      routeName,
      orderBy,
      defaultDistance,
      maxDistance,
      preOrderEnd,
      preOrderStart,
      adminWard,
      adminWardName,
      postalCode,
      preOrder,
      flatNumber,
      city,
      hasMore,
      visibleLoadMore,
      scrolled,
      isPostalCode,
      isMobile,
      customList
    } = this.state;
    let href;
    if (adminWard) {
      href = `/restaurants/${city}/${adminWard}/?postcode=${postalCode}&time=${preOrder ||
        "now"}`;
    } else {
      href = `/restaurants/${city}/list/?postcode=${postalCode}&time=${preOrder ||
        "now"}`;
    }

    return (
      (loading && <RestaurantsLoading />) || (
        <React.Fragment>
          <CommonHeader active="restaurantList" />
          {postalCode && (
            <MobileFilterSection
              changeDeliveryDetails={this.changeDeliveryDetails}
              getFilter={this.getFilter}
              handleFilterSection={this.handleFilterSection}
            />
          )}

          {(!search && (
            <DesktopSearchBar
              preOrderStart={preOrderStart}
              preOrderEnd={preOrderEnd}
              query={query}
              capitalizeFirstLetter={capitalizeFirstLetter}
              orderBy={orderBy}
              handleChangeQuery={this.handleChangeQuery}
              handleKeyUp={this.handleKeyUp}
              handleCloseSearchBar={this.handleCloseSearchBar}
              handleSearchBar={this.handleSearchBar}
              submitFilter={this.submitFilter}
            />
          )) || <noscript />}

          {(searchBar && (
            <div>
              <SearchDesktop
                onRemoveQuery={this.onRemoveQuery}
                onSubmitCategory={this.onSubmitCategory}
                regexCategories={regexCategories}
              />
            </div>
          )) || <noscript />}

          <Breadcrumbs
            query={query}
            adminWardName={adminWardName}
            flatNumber={flatNumber}
            postalCode={postalCode}
            routeName={routeName}
            isPostalCode={isPostalCode}
            capitalizeFirstLetter={capitalizeFirstLetter}
            href={href}
          />
          <Announcements lat={lat} lon={lon} userAddressId={userAddressId} />

          <div className="restaurant-list">
            <List
              restaurants={restaurants}
              postalCode={postalCode}
              changeDeliveryDetails={this.changeDeliveryDetails}
              changeDelivery={changeDelivery}
              filterSection={filterSection}
              handleFilterSection={this.handleFilterSection}
              submitFilter={this.submitFilter}
              searchBar={searchBar}
              onCloseSection={this.onCloseSection}
              onSubmitCategory={this.onSubmitCategory}
              onRemoveQuery={this.onRemoveQuery}
              regexCategories={regexCategories}
              routeName={routeName}
              flatNumber={flatNumber}
              maxDistance={maxDistance}
              defaultDistance={defaultDistance}
              preOrderStart={preOrderStart}
              preOrderEnd={preOrderEnd}
              orderBy={orderBy}
              isMobile={isMobile}
              scrolled={scrolled}
              customList={customList}
            />
            <LoadMore
              hasMore={hasMore}
              visibleLoadMore={visibleLoadMore}
              getMoreRestaurants={this.getMoreRestaurants}
            />
          </div>

          <Basket />
        </React.Fragment>
      )
    );
  }
}

export default withRouter(Restaurants);
